module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-mobile.6211301d.png";